module.exports = __webpack_public_path__ + "static/img/no-cupones-icon.bfcb0e19.png";